export default "__VITE_ASSET__BGQfXsKI__"